// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bcr_a bhi_b bhi_uy bhi_rt bhi_ru bhi_vs","PanelFooter--link":"bcr_b"};